import React from 'react';
import { restoreV5RelativeTo, getRouterAdapter } from './utils';
import type { LeagueNavigateProps } from './router-types';

/**
 * Wrapper around react-router-dom's Navigate component that ensures all `to`s are treated
 * as absolute. Helps bridge between v5 APIs, which (more or less) treats all `to`s
 * as absolute, and v6 APIs, which treats `to`s without a leading slash as relative.
 *
 * @deprecated use `Navigate` instead.
 */
export const NavigateLegacy = ({ to, ...rest }: LeagueNavigateProps) => {
  const adapter = getRouterAdapter();
  const { pathname } = adapter.useLocation();
  const { Navigate } = adapter;
  return (
    <Navigate
      relative="path"
      to={restoreV5RelativeTo(to, pathname)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};
